export default __webpack_public_path__ + "static/media/tempStore10.31120ab6.png";